import { render, staticRenderFns } from "./UserBusinessPlanAgreement.vue?vue&type=template&id=0fbfb2c8"
import script from "./UserBusinessPlanAgreement.vue?vue&type=script&lang=js"
export * from "./UserBusinessPlanAgreement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports